/**
 * @file コンポーネント：フル動画ページ症例タグ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

export const StyledContent = styled.div``;

export const StyledContentEdit = styled.div`
    margin-top: 8px;
`;

export const StyledContentEditAnchor = styled.a`
    color: #eed393;
    font-size: 11px;
    line-height: 16px;
    white-space: nowrap;
`;

export const StyledContentEditAnchorIcon = styled.span`
    margin-right: 4px;
`;

export const StyledContentEditAnchorText = styled.span``;

export const StyledContentParagragh = styled.p``;

export const StyledContentTaglist = styled.ul`
    display: flex;
    flex-wrap: wrap;
    margin: 0 -8px -8px 0;
`;

export const StyledContentTaglistItem = styled.li`
    margin: 0 8px 8px 0;
`;

export const StyledContentTaglistItemAnchor = styled.a`
    display: block;
    padding: 5px 12px;
    border: 1px solid #5a6063;
    border-radius: 7px;
    color: #e3e3e4;
    font-size: 13px;
    line-height: 16px;
`;
